import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./css/all.min.css";
import "./css/normal.css";
import App from "./App";

ReactDOM.createRoot(document.getElementById("root")).render(<App />);
